import { createSlice, Dispatch } from '@reduxjs/toolkit';
import { getShopAPIURL } from '@mooncake/utils/sfcc';
import { pollWindowVariable } from '@mooncake/mooncake-gateway-ecom/utils';
import { fetchProducts } from '@mooncake/mooncake-gateway-ecom/events/sfcc';
import { IOCAPIProduct } from '../types/products';

export interface IProductsState {
  fetching: boolean;
  error: string;
  items: IOCAPIProduct[];
}

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    fetching: true,
    error: '',
    items: [],
  } as IProductsState,
  reducers: {
    fetchStart(state) {
      state.fetching = true;
    },
    fetchEnd(state) {
      state.fetching = false;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearError(state) {
      state.error = '';
    },
    setProducts(state, action) {
      state.items = action.payload;
    },
  },
});

export const { fetchStart, fetchEnd, setError, clearError, setProducts } = productsSlice.actions;

export const fetchProductsData = (productIds: string[], currency: string) => async (dispatch: Dispatch) => {
  dispatch(fetchStart());

  const geoRestrictedResourceData = await pollWindowVariable('GeoRestrictedResources');

  if (!geoRestrictedResourceData) {
    dispatch(setError('No GeoRestrictedResource found'));
    return;
  }

  const developmentShopAPIUrl = 'https://store-dev.ubi.com/s/ca_ubisoft/dw/shop/v19_8/';
  const shopAPIURL = process.env.NODE_ENV === 'development' ? developmentShopAPIUrl : getShopAPIURL();

  fetchProducts(
    {
      url: shopAPIURL as string,
      clientId: process.env.REACT_APP_OCAPI_CLIENTID,
      currency,
      expand: 'prices,availability,promotions',
    },
    productIds,
    ({ resource }: { resource: { data: IOCAPIProduct[] } }) => {
      if (resource?.data) {
        dispatch(setProducts(resource.data));
      }
      dispatch(fetchEnd());
    }
  )();
};

export default productsSlice.reducer;
